import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import RHFSelectWithInvalid from "../../../../rhf/rhfselectwithinvalid";
import { yupResolver } from "@hookform/resolvers/yup";
import { buildIncidentFollowupResponseValidationSchema } from "./incident-validation";

const IncidentFollowupResponsesForm = ({item,definitions,submitFn}) => {
    const initialValues = {
        id: null,
        whyDidThisIncidentOccur: '',
        howCouldThisIncidentHaveBeenPrevented: '',
        whatStaffTrainingNeedsWereIdentified: '',
        areThereAnyChangesNeededToTheIndividualSupportPlan: '',
        whatIsTheIndividualsCurrentStatus: '',
        whoCompletedTheAnalysis: ''
    }
    const methods = useForm({
        defaultValues: item !== null ? item : initialValues,
        resolver: yupResolver(
            buildIncidentFollowupResponseValidationSchema(definitions.usermasterlist)
        )
    });

    return(
        <>
        <label htmlFor="whydidoccur">Why did this incident occur? (analysis of cause - not restatement)</label>
                    <textarea id="whydidoccur" rows={3} style={{width: '100%'}} {...methods.register('whyDidThisIncidentOccur')} />
                    <label htmlFor="howcouldprev">How could this incident have been prevented?</label>
                    <textarea id="howcouldprev" rows={3} style={{width: '100%'}} {...methods.register('howCouldThisIncidentHaveBeenPrevented')}/>
                    <label htmlFor="stafftraining">What staff training needs were identified?</label>
                    <textarea id="stafftraining" rows={3} style={{width: '100%'}} {...methods.register('whatStaffTrainingNeedsWereIdentified')}/>
                    <label htmlFor="supportplan">Are any changes needed to the individual Support Plan?</label>
                    <textarea id="supportplan" rows={3} style={{width: '100%'}} {...methods.register('areThereAnyChangesNeededToTheIndividualSupportPlan')}/>
                    <label htmlFor="currentstatus">What is the individual's current status?</label>
                    <textarea id="currentstatus" rows={3} style={{width: '100%'}} {...methods.register('whatIsTheIndividualsCurrentStatus')}/>
                    <RHFSelectWithInvalid
                        name='whoCompletedTheAnalysis'
                        label='Who Completed This Analysis'
                        methods={methods}
                        refinedOptions={definitions.sttrttusers}
                        masterOptions={definitions.usermasterlist}
                        placeholder="--Select User--"
                        style={{width: '100%'}}
                    />
                    <div className="d-flex justify-content-end mt-2">
                        {
                            item 
                            ?
                                <Button key='edit' type="button" variant="primary" onClick={methods.handleSubmit(submitFn)} disabled={!methods.formState.isDirty}>
                                    Save Changes
                                </Button>
                            :
                                <Button key='add' type="button" variant="success" onClick={methods.handleSubmit(submitFn)} disabled={!methods.formState.isDirty}>
                                    Add Response
                                </Button>
                        }
                    </div>
        </>
    )
}

export default IncidentFollowupResponsesForm;
